import CityPageTemplate from "../city-template/CityPageTemplate";
import { merrimackConfig } from "./data";

export default function MerrimackPage() {
  return <CityPageTemplate config={merrimackConfig} />;
}